import axios from 'axios'

const apiKey = "ChKNYA8r2mQQgcD3RRmo42Th9bEtuAY2";
const host = "https://api-eu.dhl.com"

export default () => {
    return axios.create({
      baseURL: host  + `/track`,
      headers: {
        "dhl-api-key": apiKey
      }
    })
  }
